// src/components/MaintenanceNav.js
// Sticky top nav for the Maintenance module — lets the user jump between Assets, Work Orders,
// PM Schedule, Parts, Vendors, and Reports without opening the side nav. Mirrors SqfNav.js's
// pattern exactly (sticky/pill-link styling); Maintenance pages don't use LanguageContext, so
// this is plain English, unlike SqfNav's bilingual labels.
import React from 'react';
import { NavLink } from 'react-router-dom';

const LINKS = [
  { to: '/maintenance/assets', label: 'Assets' },
  { to: '/maintenance/work-orders', label: 'Work Orders' },
  { to: '/maintenance/pm-schedule', label: 'PM Schedule' },
  { to: '/maintenance/parts', label: 'Parts Inventory' },
  { to: '/maintenance/vendors', label: 'Vendors & Contractors' },
  { to: '/maintenance/reports', label: 'Reports' },
];

export default function MaintenanceNav() {
  return (
    <div
      style={{
        position: 'sticky',
        top: 'var(--topbar-height)',
        zIndex: 999,
        background: '#f8f9fa',
        borderBottom: '1px solid #dee2e6',
        overflowX: 'auto',
        whiteSpace: 'nowrap',
        WebkitOverflowScrolling: 'touch',
      }}
    >
      <div style={{ display: 'inline-flex', gap: 2, padding: '6px 12px' }}>
        {LINKS.map(link => (
          <NavLink
            key={link.to}
            to={link.to}
            style={({ isActive }) => ({
              display: 'inline-block',
              padding: '4px 12px',
              borderRadius: 20,
              fontSize: 13,
              fontWeight: isActive ? 600 : 400,
              color: isActive ? '#fff' : '#495057',
              background: isActive ? '#0d6efd' : 'transparent',
              textDecoration: 'none',
              transition: 'background 0.15s, color 0.15s',
              whiteSpace: 'nowrap',
            })}
          >
            {link.label}
          </NavLink>
        ))}
      </div>
    </div>
  );
}
